import NotificationInterface from "./notificationInterface";
import { Notification } from "../../../entities/notifications/notification";
import notification_repository from "../../../../infrastructure/repository/impl/notification/notification_repository";

class NotificationUseCases implements NotificationInterface {
  async list(): Promise<Notification[]> {
    return await notification_repository.list();
  }

  async watch(notificationID: number): Promise<void> {
    return await notification_repository.watch(notificationID);
  }

  async delete(notificationID: number): Promise<void> {
    return await notification_repository.delete(notificationID);
  }

  async get(notificationID: number): Promise<Notification> {
    return await notification_repository.get(notificationID);
  }
}

export default new NotificationUseCases() as NotificationInterface;
